import React, { useState } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import LocaleStrings from "Languages";
import { isTablet, classNames, screenHeightLeftFromTop } from "Constants";
// Componets
import AnalyticsCommonHeader from "AnalyticscommonAnalyticscommon";
import AppIcons from "AppIcons";
import Addviewbox from "./addview/index";
import Addclickbox from "./addclicked/index";

const AnalyticsAdvertisementinsight = (props) => {
  var { deviceSize } = props;
  // State declearation
  const [loading, setLoading] = useState(false);
  const [loaderdesc, setLoaderDesc] = useState(
    LocaleStrings.analytics_text_preparing_analytics
  );
  const [tabselected, setTabselected] = useState("view");

  // useEffect(() => {
  //   // didmount
  //   props.fetchadvertisementanalytics(props.session)
  //   return () => {
  //   }
  // },[]);

  // Rerender All componets on this page
  const mainCallback = () => {
    //setLoaderDesc(true);
    // console.log(1);
  };

  const onMenuSelected = (selectedtab) => {
    if (selectedtab === "click") {
      setTabselected("click");
    } else {
      setTabselected("view");
    }
  };
  let adviewsCount = 0;
  let adclickCount = 0;
  if (
    props.advertisementAnalyticscounts &&
    props.advertisementAnalyticscounts.data
  ) {
    // console.log('props.advertisementAnalyticscounts',props.advertisementAnalyticscounts);
    adviewsCount = props.advertisementAnalyticscounts.data.countadview;
    adclickCount = props.advertisementAnalyticscounts.data.countadclick;
  }

  let clicktextcolor = {
    color: "gray",
  };
  let viewtextcolor = {
    color: "gray",
  };
  //  let viewtextcolor ='gray';
  if (tabselected === "view") {
    viewtextcolor = {
      color: "white",
    };
  } else if (tabselected === "click") {
    clicktextcolor = {
      color: "white",
    };
  }
  // console.log('props.advertisementviewAnalyticsdatalist',props.advertisementviewAnalyticsdatalist)

  return (
    <div className="panel noborder-panel">
      {/* Header section */}
      {!loading ? (
        <AnalyticsCommonHeader
          finishOperationsCallback={() => mainCallback()}
          callFrom="Advertisement Insights"
        />
      ) : (
        ""
      )}

      <div
        className="panel-body scrollable-content"
        style={{ height: deviceSize.height - screenHeightLeftFromTop }}
      >
        {loading ? (
          <div className="loader-container">
            {this.renderLoader()}
            <div className="loader-info">{loaderdesc}</div>
          </div>
        ) : (
          <div>
            <ul className="nav nav-pills dashboardNavPill">
              <li
                className={classNames(
                  tabselected === "view"
                    ? "dashboardtop-box adanalyticbg"
                    : "dashboardtop-box ",
                  ""
                )}
                // onClick={onMenuSelected('view')}
                onClick={(e) => onMenuSelected("view")}
                style={{
                  width: isTablet ? 215 : 258,
                  marginLeft: "10px",
                  cursor: "default",
                  height: "136px",
                  cursor: "pointer",
                }}
              >
                <div className="tabDiv">
                  <span className="pull-right iconCircularRight">
                    <div className={`icons rounded-circle pull-right`}>
                      {AppIcons["exhiprofview"]}
                    </div>
                  </span>
                  <span className="pull-left txtLeft txtLeftSupport">
                    <p className="bigNumbers">{adviewsCount}</p>
                    <p className="smallTxt">
                      {LocaleStrings.analytics_adview_title}
                    </p>
                  </span>
                </div>
                <div className="analytics-card-lower-div">
                  <span>
                    <p
                      className="smallTxt2"
                      style={viewtextcolor}
                      // className={classNames(
                      //   tabselected === "view" ? "smallTxt2 text-muted" : "smallTxt2",
                      //   ""
                      // )}
                    >
                      {LocaleStrings.analytics_adview_description}
                    </p>
                  </span>
                </div>
              </li>
              <li
                className={classNames(
                  tabselected === "click"
                    ? "dashboardtop-box adanalyticbg"
                    : "dashboardtop-box",
                  ""
                )}
                onClick={(e) => onMenuSelected("click")}
                style={{
                  width: isTablet ? 215 : 258,
                  marginLeft: "10px",
                  cursor: "default",
                  height: "136px",
                  cursor: "pointer",
                }}
              >
                <div className="tabDiv">
                  <span className="pull-right iconCircularRight">
                    <div className={`icons rounded-circle pull-right`}>
                      {AppIcons["atninteraction"]}
                    </div>
                  </span>
                  <span className="pull-left txtLeft txtLeftSupport">
                    <p className="bigNumbers">{adclickCount}</p>
                    <p className="smallTxt">
                      {LocaleStrings.analytics_adclick_title}
                    </p>
                  </span>
                </div>
                <div className="analytics-card-lower-div">
                  <span>
                    <p className="smallTxt2" style={clicktextcolor}>
                      {LocaleStrings.analytics_adclick_description}
                    </p>
                  </span>
                </div>
              </li>
            </ul>
            <div className="mt-20"></div>
            {tabselected === "view" ? <Addviewbox /> : <Addclickbox />}
          </div>
        )}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    deviceSize: state.deviceSize,
    advertisementviewAnalyticsdatalist: state.advertisementviewAnalyticsdatalist
      ? state.advertisementviewAnalyticsdatalist.data
      : [],
    advertisementAnalyticscounts: state.advertisementAnalyticscounts,
    // advAnalyticsMenu, // cards
  };
}

export default connect(mapStateToProps, {})(AnalyticsAdvertisementinsight);
